
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("jYDii", function(module, exports) {
"use strict";
var $e8b219e65443767f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CaretLeft = void 0;

const $e8b219e65443767f$var$react_1 = $e8b219e65443767f$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $drgA8 = parcelRequire("drgA8");
const $e8b219e65443767f$var$CaretLeft = ({ fill: fill = "none" })=>{
    const caretLeftStyles = {
        display: "flex",
        transform: "rotate(90deg)",
        transformOrigin: "center"
    };
    if (fill === "filled") return $e8b219e65443767f$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: caretLeftStyles
    }, $e8b219e65443767f$var$react_1.default.createElement($drgA8.CaretDown, {
        fill: "filled"
    }));
    return $e8b219e65443767f$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: caretLeftStyles
    }, $e8b219e65443767f$var$react_1.default.createElement($drgA8.CaretDown, null));
};
module.exports.CaretLeft = $e8b219e65443767f$var$CaretLeft;

});


//# sourceMappingURL=caret-left.6714ca68.js.map
